import ApiService from '../../api.service';
const moduleName = 'servorgs/meters';
import axios from 'axios';
import { AXIOS_ERROR_INTERCEPTED } from '@/config/consts';

export default {
    metersListCancelSource: null,
    get: async function(pagination, filter) {
        this.metersListCancelSource = axios.CancelToken.source();
        try {
            let response = await ApiService.post(
                moduleName,
                {
                    ...pagination,
                    filter
                },
                { cancelToken: this.metersListCancelSource.token }
            );
            return response ? response.data : AXIOS_ERROR_INTERCEPTED;
        } catch (e) {
            console.error(e);
        }
    },
    getContracts: async (id, pagination) => {
        try {
            let response = await ApiService.get(`${moduleName}/${id}/contracts`, {
                params: {
                    ...pagination
                }
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getDetail: async id => {
        try {
            let response = await ApiService.get(`${moduleName}/${id}`);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getIndications: async (id, dateBegin, dateEnd, pagination, sort_data) => {
        try {
            let response = await ApiService.post(`${moduleName}/${id}/indications`, {
                dateBegin,
                dateEnd,
                ...pagination,
                sort_data
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    checkAccessToMeter: async id => {
        try {
            let response = await ApiService.get(`${moduleName}/${id}/checkAccess`);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    }
};
